module.exports = __webpack_public_path__ + "img/key-icon--grayscale600.6be8f0dc.svg";